import $ from "jquery";

export default class MyAccountOrders {
    constructor() {
        this.filterSelect = document.querySelector(".jsOrdersTimeSelect");
        this.ordersItems = [...document.querySelectorAll(".jsOrderItem")];
        this.msPerDay = 1000 * 60 * 60 * 24;

        if (this.filterSelect && this.ordersItems.length) {
            this.events();
        }
    }

    events() {
        this.initializeSelectField();
        this.filterOrdersByDate();
    }

    initializeSelectField() {
        const select = this.filterSelect;

        $(select).select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: "dropdown-simple",
        });

        $(select).on("select2:select", () => {
            this.filterOrdersByDate();
        });
    }

    dateDiffInDays(a, b) {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / this.msPerDay);
    }

    filterOrdersByDate() {
        let filterDate = null;
        const currentDate = new Date();
        const selectedFilter = this.filterSelect.value;

        switch (selectedFilter) {
            case "1-month":
                filterDate = new Date(
                    currentDate.setMonth(currentDate.getMonth() - 1)
                );
                break;
            case "3-months":
                filterDate = new Date(
                    currentDate.setMonth(currentDate.getMonth() - 3)
                );
                break;
            case "6-months":
                filterDate = new Date(
                    currentDate.setMonth(currentDate.getMonth() - 6)
                );
                break;
            case "1-year":
                filterDate = new Date(
                    currentDate.setMonth(currentDate.getMonth() - 12)
                );
                break;
            default:
                filterDate = null;
        }

        if (filterDate === null) {
            this.ordersItems.forEach((order) =>
                order.classList.remove("is-hidden")
            );
        } else {
            this.ordersItems.forEach((order) => {
                const orderDate = new Date(order.dataset.time);
                const difference = this.dateDiffInDays(orderDate, filterDate);

                difference > 0
                    ? order.classList.add("is-hidden")
                    : order.classList.remove("is-hidden");
            });
        }
    }
}
